module.exports = __webpack_public_path__ + "img/logo-dark.cdf02fd2.png";